import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";

const HeaderLogo = ({user, profile, profileLoading, env}) => {
    if (profileLoading) {
        return <div/>;
    }
    const brandLogoSrc = profile?.brandLogo;
    const isHeightZero = env.NAME === "HeightZero";
    const isBitgo = env.NAME && env.NAME.startsWith("BitGo ");
    const subtitle = isBitgo ? env.NAME.replace("BitGo ", "") : "";
    const isLogo = !isHeightZero && !isBitgo && env.BANNER && env.BANNER !== "text";
    return (
        <div className="d-flex justify-content-between align-items-center">
            <div className="navbar-brand-box">
                {/* If a brand logo is available, show that by default. Otherwise, base the logo on environment variables. */}
                {brandLogoSrc ? (
                    <Link key="brand-logo-link" to="/">
                        <img key="brand-logo" alt="cobrand" src={brandLogoSrc}
                             style={{padding: "1rem 0", height: "70px"}}/>
                    </Link>
                ) : isHeightZero ? (
                    <Link to="/" className="logo-text">
                        HEIGHT<span className="font-weight-light">ZERO</span>
                    </Link>
                ) : isBitgo ? (
                    <Link to="/" className="logo-text-bitgo">
                        BitGo<br/>
                        <span style={{fontSize: "10px"}}>{subtitle}</span>
                    </Link>
                ) : isLogo ? (
                    <Link to="/" className="logo">
                        <img src={"/" + env.BANNER} alt="logo"
                             style={{padding: "1rem 0", height: "70px"}}/>
                    </Link>
                ) : (
                    <Link to="/" className="logo-text">
                        {env.NAME}
                    </Link>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    const {user, profile, profileLoading} = state.User;
    const {env} = state.Variables;
    return {user, profile, profileLoading, env};
};

export default connect(mapStateToProps, {})(HeaderLogo);
